import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900 } from 'material-ui/styles/colors';

const propTypes = {
  options: PropTypes.any,
  option: PropTypes.any,
  onSave: PropTypes.func,
};

class ViewOption extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    let option = nextProps.option;
    if (option.id) {
      option = nextProps.option;
    } else {
      option = nextProps.options.results[0];
    }
    option.id = (option.id === null) ? 0 : option.id;
    this.setState({ option });
  }
  navigateToEdit() {
    browserHistory.push(`/options/${this.props.option.id}`);
  }
  handleCancel() {
    browserHistory.push('/options');
  }
  render() {
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
    };
    return (
      <div>
        <div>
          <div className="float-right">
            <RaisedButton
              style={{ marginRight: '20px' }}
              label="Cancel"
              primary
              onClick={this.handleCancel}
            />
            <RaisedButton
              label="Edit"
              primary
              onClick={this.navigateToEdit}
            />
          </div>
          <br />
          <TextField
            floatingLabelText="ID"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.options.option.id}
          />
          <br />
          <TextField
            floatingLabelText="Name"
            floatingLabelStyle={styles.floatingLabelStyle}
            value={this.props.options.option.name}
            name="name"
            style={styles.inputStyle}
          />
        </div>
      </div>
    );
  }
}

ViewOption.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewOption.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    options: state.options,
    option: state.options.option,
  };
}

export default connect(mapStateToProps)(ViewOption);



// WEBPACK FOOTER //
// ./src/components/options/ViewOption.js